import StorageFactory from "./StorageFactory";
import { clearAuthToken } from "./jwtAuth";

/** Structured reject payload when subscription status API returns 404 */
export const buildUserNotFoundError = (message = "User not found") => ({
  userNotFound: true,
  statusCode: 404,
  message,
});

export const isUserNotFoundError = (payload) =>
  Boolean(payload && typeof payload === "object" && payload.userNotFound);

/**
 * API may return HTTP 400 with JSON body `{ status_code: 404, message: "User not found" }`.
 */
export const getUserNotFoundFromApiBody = (data) => {
  if (!data || typeof data !== "object") return null;
  if (Number(data.status_code) === 404) {
    return buildUserNotFoundError(data.message || "User not found");
  }
  return null;
};

export const getUserNotFoundFromAxiosError = (error) =>
  getUserNotFoundFromApiBody(error?.response?.data);

/**
 * Clear session, local storage, and service-worker caches (same as login reset).
 */
export const clearAuthSession = async () => {
  clearAuthToken();
  const sessionFactory = new StorageFactory("session");
  sessionFactory.clear();

  if (typeof window !== "undefined") {
    localStorage.clear();
  }

  if (typeof window !== "undefined" && "caches" in window) {
    try {
      const cacheNames = await caches.keys();
      await Promise.all(cacheNames.map((name) => caches.delete(name)));
    } catch (err) {
      console.error("Cache clear error:", err);
    }
  }
};
